// extracted by mini-css-extract-plugin
module.exports = {"form":"Login_form__3bufY","inputGroup":"Login_inputGroup__2Z7Y9","inputGroupHeader":"Login_inputGroupHeader__2w2HG"};